import PropTypes from 'prop-types';
import React from 'react';
import { List } from 'immutable';
import { Link } from 'react-router-dom';

import Offer from '../../../containers/betslip/Offer';

import style from './BetBuilderBets.module.scss';
import commonStyles from '../stylesheets/shared.module.scss';

const BetBuilderBets = ({
  onUpdateOffers,
  onSubmitUnmatched,
  onSubmitOffers,
  onCancelOffers,
  onCancelUnmatchedOffers,
  onReviewOffer,
  currency,
  openOffers: offers,
}) => {
  const onUseBonusUpdate = (cid) => {
    offers.forEach((offer) => {
      if (offer.cid === cid) {
        onUpdateOffers({
          cid: offer.cid,
          id: offer.id,
          useBonus: false
        });
      }
      return offer;
    });
  };

  let previousIteration = {};

  const bets = offers
    .sortBy(offer => offer.side)
    .sortBy(offer => offer.marketId)
    .sortBy(offer => offer.eventId);

  return (
    <div className={style.offers}>
      <div className={commonStyles.container}>
        <div className={style.containerScrollable}>
          {bets.map((offer) => {
            const arr = [];
            if (offer.eventId !== previousIteration.eventId) {
              arr.push(
                <div className={commonStyles.containerHeader} key={offer.id}>
                  <Link
                    to={`/events/${offer.eventId}`}
                    className={commonStyles.eventLink}
                  >
                    <span>{offer.eventName}</span>
                  </Link>
                  <div className={commonStyles.containerSecondRow}>
                    <span>Odds</span>
                    <span className={style.marginTitles}>Stake</span>
                    <span>PnL</span>
                  </div>
                </div>
              );
            }
            arr.push(<Offer
              offer={offer}
              onUpdateOffer={onUpdateOffers}
              onSubmitOffer={onSubmitOffers}
              onSubmitUnmatched={onSubmitUnmatched}
              onCancelOffer={onCancelOffers}
              onCancelUnmatchedOffers={onCancelUnmatchedOffers}
              onReviewOffer={onReviewOffer}
              onUseBonusUpdate={onUseBonusUpdate}
              key={`offer_${offer.cid}_${offer.id}`}
              currency={currency}
            />);

            previousIteration = offer;
            return arr;
          }).toArray()}
          {bets.size === 0 && (
            <div className={commonStyles.noOffers}>
              <span className={style.noOffersLabel}>No Selections</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

BetBuilderBets.propTypes = {
  onUpdateOffers: PropTypes.func.isRequired,
  onSubmitOffers: PropTypes.func.isRequired,
  onSubmitUnmatched: PropTypes.func.isRequired,
  onCancelOffers: PropTypes.func,
  onCancelUnmatchedOffers: PropTypes.func,
  onReviewOffer: PropTypes.func,
  currency: PropTypes.string,
  openOffers: PropTypes.instanceOf(List).isRequired,
};

export default BetBuilderBets;
